module.exports = __webpack_public_path__ + "static/media/business (1).98e88daa.svg";